<!-- <div class="ui container" appMargin appPadding paddingB='30'> -->

<div class="ui vertical basic segment" [ngClass]="{ loading: pending }">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <div
      fxLayoutAlign="start center"
      fxLayout="row"
      fxLayoutGap="20px"
      (click)="goBack()"
      class="link"
    >
      <div>
        <img src="assets/icons/left-arrow-icon.svg" alt="" />
      </div>
      <div class="equipment-id">
        <!-- Title -->
        <h2 class="ui primary header">{{ role?.roleName }}</h2>
      </div>
    </div>

    <div fxLayout="row" fxLayoutGap="15px">
      <button
        class="ui basic small primary button"
        (click)="deleteRole()"
        suiPopup
        [popupInverted]="true"
        popupPlacement="bottom"
        popupText="delete role"
        *ngIf="
          role?.roleId !== 'CONTRACTOR_MID_LEVEL_STAFF' &&
          role?.roleId !== 'CONTRACTOR_ADMIN' &&
          role?.roleId !== 'CONTRACTOR_BASIC_STAFF'
        "
      >
        Delete
      </button>
      <button
        class="ui small primary button"
        (click)="editRole()"
        suiPopup
        *ngIf="
          roleId !== 'CONTRACTOR_MID_LEVEL_STAFF' &&
          roleId !== 'CONTRACTOR_ADMIN' &&
          roleId !== 'CONTRACTOR_BASIC_STAFF'
        "
        [popupInverted]="true"
        popupPlacement="bottom"
        popupText="edit role"
      >
        Edit
      </button>
    </div>
  </div>
  <div class="ui divider" appMargin marginY="3"></div>
  <div *ngIf="success || error" tamsyMargin marginY="10px">
    <esl-message-toast [(message)]="error"></esl-message-toast>
    <esl-message-toast
      [(message)]="success"
      [messageType]="'success'"
    ></esl-message-toast>
  </div>
</div>

<div fxLayout="row" fxLayoutGap="50px">
  <div fxFlex="25%">
    <div class="ui form side-panel" appPadding="15px">
      <div class="field" appMargin marginB="10">
        <label>TITLE</label>
        <h3 appMargin="0px" class="ui primary header">{{ role?.roleName }}</h3>
      </div>
      <div class="field" appMargin marginB="10">
        <label>DESCRIPTION</label>
        {{ role?.roleDescription }}
      </div>
      <div class="field" appMargin marginB="10">
        <label>DATE CREATED</label>
        {{
          role?.dateCreated
            ? (role.dateCreated | date: "d MMM, y h:mm a")
            : "Nil"
        }}
      </div>
      <div class="field" appMargin marginB="10">
        <label>CREATED BY</label>
        {{ role?.createdBy ? (role.createdBy | createdByOrg) : "Nil" }}
      </div>
      <div class="field" appMargin marginB="10">
        <label>LAST EDITED</label>
        {{
          role?.dateModified
            ? (role.dateModified | date: "d MMM, y h:mm a")
            : "Nil"
        }}
      </div>
      <div class="field" appMargin marginB="10">
        <label>EDITED BY</label>
        {{ role?.modifiedBy ? (role.modifiedBy | createdByOrg) : "Nil" }}
      </div>
    </div>
  </div>
  <div fxFlex="grow">
    <div class="ui segment">
      <div appPadding paddingB="15px">
        <div fxLayout="row">
          <div fxFlex="grow"></div>
          <div fxFlex="10%">READ</div>
          <div fxFlex="10%">CREATE</div>
          <div fxFlex="10%">EDIT</div>
          <div fxFlex="10%">DELETE</div>
        </div>

        <div class="ui divider"></div>

        <ng-template
          ngFor
          let-permission
          [ngForOf]="selectedRolePermissions"
          let-i="index"
        >
          <div fxLayout="column" *ngIf="permission.groupName && i == 0">
            <div>
              <strong> {{ permission?.groupName | uppercase }} </strong>
            </div>
            <div class="ui divider"></div>
          </div>
          <div
            fxLayout="column"
            *ngIf="permission.groupName && i != 0"
            appMargin
            marginT="15"
          >
            <div>
              <strong> {{ permission?.groupName | uppercase }} </strong>
            </div>
            <div class="ui divider"></div>
          </div>
          <div
            fxLayout="row"
            *ngFor="let perm of permission.permissions"
            appMargin
            marginB="7"
          >
            <div fxFlex="grow">
              {{ perm?.permissionDesc }}
            </div>

            <div fxFlex="10%">
              <!-- <sui-checkbox
                                      [(ngModel)]="perm.read" >
                                       </sui-checkbox> -->
              <input
                disabled
                [checked]="perm.read === checkOptions[0].value"
                [value]="perm.read"
                name="read"
                type="checkbox"
              />
            </div>

            <div fxFlex="10%">
              <input
                disabled
                [checked]="perm.add === checkOptions[0].value"
                [value]="perm.add"
                name="add"
                type="checkbox"
              />
            </div>

            <div fxFlex="10%">
              <input
                disabled
                [checked]="perm.edit === checkOptions[0].value"
                [value]="perm.edit"
                name="edit"
                type="checkbox"
              />
            </div>

            <div fxFlex="10%">
              <input
                disabled
                [checked]="perm.remove === checkOptions[0].value"
                [value]="perm.remove"
                name="remove"
                type="checkbox"
              />
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </div>
</div>

<!-- </div> -->
